export default __webpack_public_path__ + "static/media/557.b479ae53.jpg";